import {combineReducers} from 'redux';
import userReducer from './user';
import {type InitialState as UserState} from "./user/types";
import {type InitialState as CourseState} from "./course/types";
import {type InitialState as GroupState} from "./group/types";
import {type InitialState as OrganisationState} from "./organisation/types";
import { type InitialState as AttestationState} from './attestation/types';
import groupReducer from './group';
import courseReducer from './course';
import organisationReducer from './organisation';
import attestationReducer from './attestation';

export type CommonState = {
   user: UserState,
   course: CourseState,
   group: GroupState,
   organisation: OrganisationState,
   attestation: AttestationState,
};

const rootReducer = combineReducers({
   user: userReducer,
   course: courseReducer,
   group:  groupReducer,
   organisation: organisationReducer,
   attestation: attestationReducer,
}) as unknown as CommonState;

export default rootReducer;